import { render, staticRenderFns } from "./edit-sme-kyc.vue?vue&type=template&id=a886e3f0&scoped=true&"
import script from "./edit-sme-kyc.vue?vue&type=script&lang=js&"
export * from "./edit-sme-kyc.vue?vue&type=script&lang=js&"
import style0 from "./edit-sme-kyc.vue?vue&type=style&index=0&id=a886e3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a886e3f0",
  null
  
)

export default component.exports